/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import heroImage from '../../components/Login/dream-it-reel.png';
import { routesAction } from '../../shared/helpers';
import {
  confirmEmail,
  loginByToken,
  logout,
  resetPasswordToken,
} from '../../store/actions/Authentication';

class EmailConfirmation extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { search } = this.props.location;
    const [, confirmation_token] = search.split('=');
    this.props.dispatchConfirmEmail(
      confirmation_token,
      this.props.currentUser.email,
    );
  }

  render() {
    const { isFetching, emailConfirmed, currentUser } = this.props;
    const alreadyConfirmed = !isFetching && !emailConfirmed;

    return (
      <div className="container">
        <div className="col col-lg-6 mx-auto">
          <div className="pt-5 mt-2 row text-center">
            <div className="col-12">
              <img alt="logo" className="mb-3" src={heroImage} />
            </div>
            <div className="col-12">
              <p className="t-15 mt-4 mb-4 text-gray create-account-header-text">
                AN ELITE NETWORK OF VIDEO CREATORS AT YOUR FINGERTIPS
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-7 mx-auto">
            <div className="bg-white shadow-card p-5">
              <div className="form-row">
                <div className="col mb-3 mt-4 text-center">
                  {isFetching && (
                    <p className="text-darkgreen font-weight-bold mb-3">
                      Validating your email...
                    </p>
                  )}

                  {emailConfirmed && (
                    <p className="text-darkgreen font-weight-bold mb-3">
                      Click <a href="/">here</a> to go to your dashboard.
                    </p>
                  )}

                  {alreadyConfirmed && (
                    <p className="text-darkgreen font-weight-bold mb-3">
                      Click <a href="/">here</a> to sign in.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EmailConfirmation.propTypes = {
  location: PropTypes.object,
  dispatchConfirmEmail: PropTypes.func,
  emailConfirmed: PropTypes.bool,
  isFetching: PropTypes.bool,
};

const mapStateToProps = state => ({
  isFetching: state.authentication.isFetching,
  emailConfirmed: state.authentication.emailConfirmed,
  currentUser: state.authentication.user,
  isLogin: state.authentication.isLogin,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchConfirmEmail: confirmation_token => {
    dispatch(confirmEmail(confirmation_token)).then(response => {
      if (response && response.type === 'CONFIRM_EMAIL_SUCCESS') {
        const {
          payload: { data },
        } = response;
        dispatch(resetPasswordToken(data))
          .then(() => dispatch(loginByToken(data)))
          .then(() => ownProps.history.push(routesAction.default()));
      } else ownProps.history.push(routesAction.login());
    });
  },
  dispatchLogout: () => dispatch(logout()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmailConfirmation);



// WEBPACK FOOTER //
// ./src/containers/EmailConfirmation/EmailConfirmation.js